import React from "react";
import PracticeQuestionsCore from "./PracticeQuestionsCore";

const PracticeQuestionsPreview = props => {
    const {conceptId, questionLevel, displayHeader = false} = props;

    return (
        <PracticeQuestionsCore
            conceptId={conceptId}
            questionLevel={questionLevel}
            displayHeader={displayHeader}
            previewMode={true}
        />
    )
}

export default PracticeQuestionsPreview;